import type { Immutable } from "immer";
import React from "react";
import { getGlobalSpacingClasses } from "tsi-common-react/src/components/_spacing/globalSpacing";
import { t } from "ttag";

import type { ValuePropListBlock as ValuePropListBlockValue } from "@reactivated";

import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import {
    EditableUserLocation,
    ShippingArrivalDate,
    useShippingLocalization,
} from "../ShippingLocalization";

import styles from "./index.module.scss";

export const CocoonValuePropListBlock = (
    props: Immutable<{ value: ValuePropListBlockValue }>,
): React.JSX.Element => {
    const value = props.value;
    const localization = useShippingLocalization();
    const valuePropsHTML = (value.value_props ?? [])
        .map((prop, i) => `${i > 0 ? "&#183; " : ""}${prop.title}`)
        .join("");
    return (
        <section
            className={concatClassNames([
                "value-prop-list-block",
                styles.valuePropListBlock,
                getGlobalSpacingClasses(value.spacing),
            ])}
        >
            <div className="main-container">
                <div
                    className={concatClassNames([
                        "value-prop-list-block__props",
                        styles.valuePropListBlockProps,
                    ])}
                    dangerouslySetInnerHTML={{ __html: valuePropsHTML }}
                />
                {value.show_shipping_callout ? (
                    <p
                        className={concatClassNames([
                            "value-prop-list-block__shipping",
                            styles.valuePropListBlockShipping,
                        ])}
                    >
                        <span
                            className="l10n-fill-shipping-estimate"
                            data-prefix={t`Delivered by UPS to `}
                        >
                            {localization.locationDisplayName
                                ? t`Delivered by UPS to `
                                : t`Estimate your ship time:`}
                        </span>
                        <EditableUserLocation localization={localization} />
                        <ShippingArrivalDate
                            localization={localization}
                            prefix={t` as soon as `}
                        />
                        .
                    </p>
                ) : null}
            </div>
        </section>
    );
};
